import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {LoginBody, LoginResponse, ForgotPasswordBody, ForgotPasswordResponse, ResetPasswordBody, ResetPasswordResponse} from './login.interface';
import {Observable} from 'rxjs';
import {HttpCommonService} from '../../../shared/services/http-common.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  login(body: LoginBody): Observable<LoginResponse> {
    const url = this.httpCommonService.makeUrl('/auth/login');
    return this.http.post<LoginResponse>(url, body);
  }

  forgotPassword(body: ForgotPasswordBody): Observable<ForgotPasswordResponse> {
    const url = this.httpCommonService.makeUrl('/auth/forgot-password');
    return this.http.post<ForgotPasswordResponse>(url, body);
  }

  resetPassword(body: ResetPasswordBody): Observable<ResetPasswordResponse> {
    const url = this.httpCommonService.makeUrl('/auth/reset-password');
    return this.http.post<ResetPasswordResponse>(url, body);
  }

}
